import styled from 'styled-components'
import QRCode from 'qrcode.react'

export const Form = styled.form``

export const FormWrapper = styled.div`
  margin: 10px 0;
  padding: 10px;
  min-width: 200px;
  background: ${(props) => props.theme.background_primary};
  background-color: white;
  height: 100%;
  text-align: center;
`

// Full-screen forms
export const FormContainer = styled.div`
  padding: 20px;
  margin: 30px 0;
  min-width: 200px;
  height: 100%;
  border-color: #d3d2c9;
  border-style: solid;
  border-width: 1px;
  border-radius: 7px;
  background: ${(props) => props.theme.background_primary};
  background-color: white;
`
export const Label = styled.label`
  margin-right: 180px;
  width: 10%;
  font-size: 16px;
  text-align: left;
  color: ${(props) => props.theme.text_color};
`

// Modal forms
export const Modal = styled.div`
  overflow: hidden;
  margin: auto;
  padding: 10px;
  max-height: 90vh;
  width: 70%;
  font-size: 12px;
  border: 1px solid #d7d7d7;
  background: white;
`
export const ModalContent = styled.div`
  height: 99%;
  width: 100%;
  padding: 10px 5px;
  overflow-y: auto;
  font-size: 24px;
`

/* Icons */
export const Icon = styled.img`
  width: 17px;
  vertical-align: middle;
`
export const IconAvatar = styled.img`
  width: 17px;
  vertical-align: middle;
`
export const IconHelp = styled.img`
  width: 14px;
  vertical-align: middle;
`
export const IconLanguage = styled.img`
  width: 17px;
  vertical-align: middle;
`

/* Buttons */
export const Btn = styled.button`
  padding: 0 27px;
  height: 28px;
  font-size: 12px;
  line-height: 27px;
  font-weight: 700;

  border: none;
  border-radius: 14px;

  :hover {
    cursor: pointer;
  }
`
export const BtnPrimaryLight = styled.button`
  padding: 0 20px;
  height: 28px;
  font-size: 12px;
  line-height: 27px;
  font-weight: 700;
  color: #ef7d00;

  border: none;
  border-radius: 14px;
  background-color: #fff;

  :hover {
    cursor: pointer;
  }
`
export const BtnPrimaryLarge = styled.button`
  padding: 0 40px;
  height: 44px;

  font-size: 20px;
  line-height: 43px;
  font-weight: 700;
  color: #fff;

  border: none;
  border-radius: 22px;
  background-color: #ef7d00;

  :hover {
    cursor: pointer;
  }
`
export const BtnSecondary = styled.button`
  padding: 0 27px;
  height: 28px;

  font-size: 16px;
  line-height: 27px;
  font-weight: 700;
  color: #fff;

  border: none;
  border-radius: 14px;
  background-color: #0069b4;

  :hover {
    cursor: pointer;
  }
`
export const BtnSecondaryLarge = styled.button`
  padding: 0 40px;
  height: 44px;

  font-size: 16px;
  line-height: 43px;
  font-weight: bold;
  color: #fff;

  border: none;
  border-radius: 22px;
  background-color: #ffffff;

  :hover {
    cursor: pointer;
  }
`
export const BtnSecondaryLightLarge = styled.button`
  padding: 0 40px;
  height: 44px;

  font-size: 20px;
  line-height: 43px;
  font-weight: bold;
  color: #ffffff;

  border: 1px solid #ffffff;
  border-radius: 22px;
  background-color: #fff;

  :hover {
    cursor: pointer;
  }
`
export const BtnTertiaryLightLarge = styled.button`
  padding: 0 40px;
  height: 44px;

  font-size: 20px;
  line-height: 44px;
  font-weight: bold;
  color: #222;

  border: none;
  border-radius: 22px;
  background-color: white;

  :hover {
    cursor: pointer;
  }
`

/* The only button style that doesn't follow the general scheme, LOL */
export const BtnDashboard = styled.button`
  padding: 0 20px;
  height: 28px;
  font-size: 12px;
  line-height: 27px;
  font-weight: bold;
  color: #fff;

  border: 1px #fff solid;
  border-radius: 15px;
  background-color: transparent;

  :hover {
    cursor: pointer;
  }
`

export const QR = styled(QRCode)`
  display: block;
  height: 350px;
  width: 350px;
  margin: auto;
  padding: 20px;
  background: #fff;
`
